export default (that) => [
  {
    type: 'seq',
    title: '#',
    width: 50,
    align: 'center',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    width: 100,
    fixed: 'right',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'opt' },
  },
  {
    field: 'transportNo',
    title: that.$l('form_label_transportNo') || '外运编号',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'bookingTypeName',
    title: that.$l('form_label_bookingType') || '订舱类型',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'bookingTypeNameHeader' },
  },
  {
    field: 'shipVoyage',
    title: that.$l('form_label_shipVoyage') || '船名航次',
    minWidth: 220,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'shipVoyageHeader' },
  },
  {
    field: 'dispatchPortName',
    title: that.$l('form_label_dispatchPort') || '发运港口',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'dispatchPortNameHeader' },
  },
  {
    field: 'destinationPortName',
    title: that.$l('form_label_destinationPort') || '目的港口',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'destinationPortNameHeader' },
  },
  {
    field: 'destinationPortFullName',
    title: that.$l('form_label_deliveryPort') || '指运港',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'destinationPortFullNameHeader' },
  },
  {
    field: 'destinationCountry',
    title: that.$l('form_label_destinationCountry') || '目的国',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'destinationCountryHeader' },
  },
  {
    field: 'shipmentTypeName',
    title: that.$l('table_label_dispatchType') || '出运方式',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'shipmentTypeNameHeader' },
  },
  {
    field: 'quotedMethodName',
    title: that.$l('form_label_quotedMethod') || '报价方式',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'quotedMethodNameHeader' },
  },
  {
    field: 'bookingDate',
    title: that.$l('form_label_bookingDate') || '订舱日期',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'bookingDateHeader' },
  },
  {
    field: 'deliveryDate',
    title: that.$l('table_label_loadingDate') || '产装日期',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'deliveryDateHeader' },
  },
  {
    field: 'eta',
    title: that.$l('table_label_eta') || '到港日期',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'etaHeader' },
  },
  {
    field: 'fbaArrivalDate',
    title: that.$l('form_label_fbaArrivalDate') || '到FBA日期',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'fbaArrivalDateHeader' },
  },
  {
    field: 'bookingScmName',
    title: that.$l('form_label_bookingScmCode') || '订舱货代',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'bookingScmNameHeader' },
  },
  {
    field: 'customsBrokerScmName',
    title: that.$l('form_label_customsBrokerScmCode') || '报关货代',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'customsBrokerScmNameHeader' },
  },
  {
    field: 'domesticTransitName',
    title: that.$l('form_label_domesticTransitScmCode') || '境内运输公司',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'domesticTransitNameHeader' },
  },
  {
    field: 'overseasTransitName',
    title: that.$l('form_label_overseasTransitScmCode') || '境外运输公司',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'overseasTransitNameHeader' },
  },
  {
    field: 'shipperName',
    title: that.$l('form_label_shipperCode') || '发货人',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'shipperNameHeader' },
  },
  {
    field: 'consigneeName',
    title: that.$l('form_label_consigneeCode') || '收货人',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'consigneeNameHeader' },
  },
  {
    field: 'notifierName',
    title: that.$l('form_label_notifierCode') || '通知人',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'notifierNameHeader' },
  },
  {
    field: 'totalGoodsQty',
    title: that.$l('form_label_totalGoodsQty') || '产品总数量',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalCtnQty',
    title: that.$l('form_label_totalCtnQty') || '总箱数',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalGrossWeight',
    title: that.$l('table_label_totalGrossWeight') || '总毛重(kg)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalNetWeight',
    title: that.$l('table_label_totalNetWeight') || '总净重(kg)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalVolume',
    title: that.$l('table_label_totalVolume') || '总体积(m³)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalBookingVolume',
    title: that.$l('table_label_totalBookingVolume') || '订舱总体积(m³)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalCostAmount',
    title: that.$l('table_label_costAmount') || '成本金额',
    width: 140,
    align: 'center',
    formatter: ({ row }) => {
      return [
        row.totalCostAmount || '0',
        row.costCurrencyUnitName || row.costCurrencyUnit,
      ]
        .filter(Boolean)
        .join(' ')
    },
    showHeaderOverflow: true,
  },
  {
    field: 'totalSalesAmount',
    title: that.$l('table_label_salesAmount') || '销售金额',
    width: 140,
    align: 'center',
    formatter: ({ row }) => {
      return [
        row.totalSalesAmount || '0',
        row.salesCurrencyUnitName || row.salesCurrencyUnit,
      ]
        .filter(Boolean)
        .join(' ')
    },
    showHeaderOverflow: true,
  },
]
